import React from "react";
import { Modal, Button } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";

export default function OrderSuccessModal({ visible, orderId, onClose }) {
  return (
    <Modal
      visible={visible}
      centered
      width={420}
      footer={null}
      closable={true}
      onCancel={onClose}
      bodyStyle={{ textAlign: "center", padding: "40px 30px" }}
    >
      <CheckCircleFilled style={{ fontSize: 60, color: "#4CAF50", marginBottom: 20 }} />

      <h2 style={{ marginBottom: 5 }}>Order Created Successfully!</h2>
      <p style={{ color: "#6c757d", marginBottom: 25 }}>
        Your order has been created and is ready for processing
      </p>

      <div
        style={{
          background: "#f6f8fc",
          padding: "18px",
          borderRadius: 10,
          fontSize: 16,
          fontWeight: 600,
          marginBottom: 30,
        }}
      >
        <div style={{ fontSize: 12, color: "#6c757d", marginBottom: 4 }}>Order ID</div>
        {orderId }
      </div>

      <Button
        type="primary"
        block
        style={{
          height: 45,
          fontSize: 16,
          borderRadius: 8,
          background: "#000D33",
        }}
        onClick={onClose}
      >
        Close
      </Button>
    </Modal>
  );
}
